export default {
  id: 'asset.tagId',
  name: 'asset.tagId',
  displayName: 'Asset Tag',
  valueType: 'string',
  objectType: 'asset',
  get: obj => {
    return obj?.data?.tag?.id;
  }
};